module.exports = __webpack_public_path__ + "static/media/classic_dream_01.d8022956.png";